@if (statusMessage() || (statusMessages() && statusMessages()!.size == 1)) {
  @if (firstStatusMessage()) {
    {{ firstStatusMessage() | siaTranslate }}
  } @else {}
} @else if (statusMessages() && statusMessages()!.size > 1) {
  {{ 'Campo non valido' | siaTranslate }}
}
